/* @ngInject */
const consultMenu = (
  $state,
  labels,
  routes
) => {
  const self = {}

  self.radio = {
    value: 'wagon',
  }

  self.items = {
    wagon: {
      ref: 'wagon',
      label: labels.wagon.title,
      go: () => {
        $state.go(routes.consult.wagon.index.path)
      },
    },
    train: {
      ref: 'train',
      label: labels.train.title,
      go: () => {
        $state.go(routes.consult.train.index.path)
      },
    },
    area: {
      ref: 'area',
      label: labels.area.title,
      go: () => {
        $state.go(routes.consult.area.index.path)
      },
    },
    railway: {
      ref: 'railway',
      label: labels.railway.title,
      go: () => {
        $state.go(routes.consult.railway.index.path)
      },
    },
    movement: {
      ref: 'movement',
      label: labels.movement.title,
      go: () => {
        $state.go(routes.consult.movement.index.path)
      },
    },
    owner: {
      ref: 'owner',
      label: labels.owner.title,
      go: () => {
        $state.go(routes.consult.owner.index.path)
      },
    },
    dispatch: {
      ref: 'dispatch',
      label: labels.dispatch.title,
      go: () => {
        $state.go(routes.consult.dispatch.index.path)
      },
    },
    stat: {
      ref: 'stat',
      label: labels.stat.title,
      go: () => {
        $state.go(routes.consult.stat.index.path)
      },
    },
    list: {
      ref: 'list',
      label: labels.list.title,
      go: () => {
        $state.go(routes.consult.list.index.path)
      },
    },
    commande: {
      ref: 'commande',
      label: labels.commande.title,
      go: () => {
        $state.go(routes.consult.commande.index.path)
      },
    },
    import: {
      ref: 'search',
      label: labels.search.title,
      go: () => {
        $state.go(routes.consult.search.index.path)
      },
    },
  }

  return self
}

export default consultMenu



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/consult.menu.js